
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organizerId]",
      function () {
        return require("private-next-pages/[organizerId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organizerId]"])
      });
    }
  